
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  cacheViews: state => state.cacheView.cacheViews
}
export default getters
